import { type CompanyConfig, TimeFormat } from '../interface';

export const OcadoConfig: CompanyConfig = {
  id: '10d2b4a2-9c0b-4394-ba3f-98e70d2bed71',
  // «Корзинка Фарма» — Korzinka Go pharmacy demo (JS-14614): Tashkent, Russian UI, prices in сум.
  // Contact details are left empty on purpose — the demo must not publish
  // made-up support addresses under a real brand.
  lang: 'ru',
  langs: ['ru'],
  name: 'Корзинка Фарма',
  nameSecondary: 'Корзинка Фарма',
  currency: 'сум',
  currencyCode: 'UZS',
  officialName: 'Корзинка Фарма',
  email: '',
  feedbackEmail: '',
  phonePlaceholder: '+998',
  defaultPhoneCode: '+998',
  // A pharmacy has no age gate (see also Company.missAgeRestrictionModal).
  ageRestricted: 0,
  timeZone: 'Asia/Tashkent',
  minimalOrderFeeThreshold: 700,
  canonical: '',
  // Pharmacy names already carry the pack size («20 шт», «25 мл»); a bare
  // «1x» under every card only adds noise (DubaiExpress does the same).
  defaultVolumeDisplay: '',
  countryCode: 'UZ',
  warehouse: {
    default: 'OCADO',
    minimalOrderFeeWarehouseCodes: [],
    // Tashkent city centre (Amir Temur square).
    location: { lat: 41.311151, lng: 69.279737 },
  },
  map: {
    center: { lat: 41.311151, lng: 69.279737 },
    zoom: 11,
  },
  paymentMethods: ['visa', 'mc', 'cash'],
  availablePaymentMethods: ['stripe'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: '',
    discount: '',
    minBasket: '',
    downloadAppLink: '',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  license: {
    name: 'Корзинка Фарма',
    numberPrinary: '',
  },
};
